/**
 * * Configuração de Botões.
 */
export class BtnConfig {

  constructor(
    /**
     * * Título (texto) do botão.
     */
    public label: string,
    /**
     * * Identificador do botão.
     */
    public id?: string,
    /**
     * * Classe do ícone do botão.
     */
    public icon?: string,
    /**
     * * Estilo Alternativo do botão
     */
    public alt?: boolean,
    /**
     * * Estilo para herdar a largura do elemento superior.
     */
    public inheritWidth?: boolean, // "inherit"
    /**
     * * Aplicar negrito na fonte
     */
    public fontBold?: boolean, 
    /**
     * * Botão Desabilitado.
     */
    public disabled?: boolean,
    /**
     * * Hint do botão.
     */
    public toolTip?: string,
    /**
     * * Local onde o Hint deve aparecer.
     */
    public placement?: 'top' | 'bottom' | 'left' | 'right' 
  ) {}

}
